'use es6';

import { Record } from 'immutable';
export default Record({
  avgSalePrice: null,
  costPerLead: null,
  currencyCode: 'USD',
  leadCloseRatePercent: null,
  portalId: null,

  isRoiCalcSet() {
    return this.avgSalePrice !== null && this.leadCloseRatePercent !== null;
  }

});